<div class="page-container">
  <div class="admin-content">
    <h1>{{ 'adminRegions.title' | translate }}</h1>
    <p class="tagline">{{ 'adminRegions.tagline' | translate }}</p>

    @if (state() === 'loading') {
      <div class="loading-container flex flex-column flex-align-center p-lg">
        <app-spinner />
      </div>
    }

    @if (state() === 'error') {
      <div class="error-container p-lg" data-testid="admin-regions-error">
        <p>{{ 'adminRegions.loadError' | translate }}</p>
      </div>
    }

    @if (state() === 'loaded') {
      <app-card>
        <app-card-content>
          <form [formGroup]="searchForm" class="search-form">
            <formly-form [form]="searchForm" [fields]="searchFields" [model]="searchModel" />
          </form>

          @if (filteredRows().length === 0) {
            <div class="empty-state p-lg" data-testid="admin-regions-no-match">
              <p>{{ 'adminRegions.noMatch' | translate }}</p>
            </div>
          } @else {
            <table class="admin-table">
              <thead>
                <tr>
                  <th>{{ 'adminRegions.column.region' | translate }}</th>
                  <th>{{ 'adminRegions.column.status' | translate }}</th>
                  <th>{{ 'adminRegions.column.updated' | translate }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for (row of filteredRows(); track row.slug) {
                  <tr [attr.data-testid]="'admin-region-row-' + row.slug">
                    <td>{{ row.name }}</td>
                    <td>
                      <span class="status-cell">
                        <span
                          class="status-badge"
                          [class]="'status-' + row.status"
                          [attr.data-testid]="'region-status-' + row.slug"
                        >
                          {{ statusLabel(row.status) }}
                        </span>
                        @if (row.status === 'building') {
                          <app-spinner class="building-spinner" [diameter]="14" [strokeWidth]="2" />
                          <span class="elapsed" [attr.data-testid]="'region-elapsed-' + row.slug">
                            {{ elapsedLabel(row) }}
                          </span>
                        }
                      </span>
                    </td>
                    <td>{{ formattedDate(row.builtAt) }}</td>
                    <td class="actions-cell">
                      <app-button
                        variant="filled"
                        [disabled]="!canBuild(row)"
                        (click)="build(row)"
                        [attr.data-testid]="'build-region-' + row.slug"
                      >
                        {{ buildLabel(row) }}
                      </app-button>
                      @if (row.lastBuildLog) {
                        <app-button
                          variant="outlined"
                          (click)="toggleLog(row)"
                          [attr.data-testid]="'toggle-log-' + row.slug"
                        >
                          {{ (row.showLog ? 'adminRegions.hideLog' : 'adminRegions.viewLog') | translate }}
                        </app-button>
                      }
                    </td>
                  </tr>
                  @if (row.showLog) {
                    <tr>
                      <td colspan="4">
                        <pre class="build-log" [attr.data-testid]="'region-log-' + row.slug">{{ row.lastBuildLog }}</pre>
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          }
        </app-card-content>
      </app-card>
    }
  </div>
</div>
